import React, { createContext, useContext, useState } from 'react';

const UIContext = createContext();

export const useUI = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
  const [hideWhatsApp, setHideWhatsApp] = useState(false);

  return (
    <UIContext.Provider value={{ hideWhatsApp, setHideWhatsApp }}>
      {children}
    </UIContext.Provider>
  );
};
